var claim =
webpackJsonp_name_([12,50],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(347);
	__webpack_require__(349);
	__webpack_require__(351);
	__webpack_require__(313);

/***/ }),

/***/ 347:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 349:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(116)['default'];
	
	var _trackerTracker = __webpack_require__(138);
	
	var _trackerTracker2 = _interopRequireDefault(_trackerTracker);
	
	$(function () {
	    var trackers = new _trackerTracker2['default']();
	
	    $('[name=form_text_3]').mask('+7(999)999-9999');
	
	    $('[name^=form_text_], [name^=form_textarea_], [name^=form_email_]').wrap('<div class="icon-field"></div>').addClass('form__input form__input--shade');
	
	    $('.js-gtm-claim-button').click(function () {
	        trackers.onFeedbackSend();
	    });
	});

/***/ })

});


// WEBPACK FOOTER //
// js/claim.363676114bb22f90733a.js